import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Lightbox } from './Lightbox';
import { useNavigate } from 'react-router-dom';

// Josie's tattoo portfolio (ready for images)
const josieTattoos = [
  { id: 1, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478718/att.acM3PFpFOJG_hXcjdJkI_6qg4gLSwqRoN22LVxKp464_iosnaq.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 2, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478714/att.wilNqUE7sZGfMOepa9P1R9A4tv-joH9Z0xPj-wb51XE_fswun5.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 3, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478712/att.ChZQ6TpPstqVMCYAGa8O9aFM3BbtMtl15gscB_aeqSk_e3d709.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 4, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478710/att.yGX9uLstRkyXNDZKcugR96wrUAUO3BOyfgrxhN3Grfk_nqdkhu.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 5, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478708/att.5cS-UaELR_0JocLDBlPZ0O66bCfoA2sZ277JtrBw-do_fdslaw.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 6, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478706/att.GGq4j9LDsUfsLe_5K-K0nFWNSMgngwD90q2cL5WrtMA_lhxjm8.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 7, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478704/att.Km9-d4AbPUvsLiDYK5QyA2Egoad1Y0yRbvsFe3thBCY_whgegi.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 8, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478702/att.fEvLEUpsEWsjqBqQPWH5Oj0d-u2z_dlsMu0e4m50FrQ_de1vqt.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 9, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478700/att.JjyHtjZ7rgpIWQrtf4UEdWuFOUULWbNcqMAmZjblTYk_yuo0qy.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 10, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478698/att.Fkvw1St2rP9UAyfoLsPpBqzM6-llMBDYo7ohaVO8-18_wwihit.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 11, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478696/att.IKkwsMUy3znGQbRF_ygCa1NkmQTbhKPctA1wfEgcBDY_nfovos.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 12, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478694/att.nTtO6H-TmwP8kvOd3Zir-stdgkxIF0I-iuj3oyhZY1Q_pbrvbh.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 13, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478692/att.EaWjbNHjEdwqFj8Be3WVzVrNZYiRj-_XNtlgCFOSxMU_s9gg9u.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 14, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478690/att.wzrDyNUsH2QYxqEgMlSSpVY0PxV32Myu2wVDF0Ae2Rw_mir2uj.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 15, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478688/att.ajySN9sANCHEmGNrMYYckXVhzTp2Jii-3vNgyEqLrWk_mzcipj.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 16, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478686/att.U5DqRCuswVWAz_7gTFhuQKWFYlLSRzKnJxRmtWABqvk_vbzmki.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 17, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478684/att.KgnvgfNun1IkXcHDjHReTuFgxvHAnVb2uvGCueKJf3o_jibd77.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 18, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478682/att.rrE8tx6bunaqe141lgWEHTdWkxFnH3SauOEsaLlv-Ps_guyuov.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 19, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478680/att.blfvWqW1bP6CyaJa-s8IiXiBTZnIjXf75OkZt2byS_U_vaimom.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 20, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478678/att.cPrngr_zQH4a9sXH8vVSl379DEXI3QUSEQysMuEBTDg_dij2pg.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
  { id: 21, url: 'https://res.cloudinary.com/ddclgpokn/image/upload/v1791478677/att.v7JRw8jGJ5Ex6-08MNZDjJ-mGuCgw-VAN48Qvf7w_9o_sguyrn.jpg', alt: 'Tattoo by Josie Handscomb - Atlantic Coast Tattoo Newquay Cornwall' },
];

// Josie's artwork portfolio (ready for images)
const josieArtwork = [];

const JosieGallery = () => {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeTab, setActiveTab] = useState('tattoos');

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Back Button */}
      <div className="fixed top-24 left-8 z-40">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
        >
          <ArrowLeft size={20} />
          <span className="text-sm tracking-wider">BACK TO HOME</span>
        </button>
      </div>

      {/* Header */}
      <section className="relative pt-32 pb-12 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="font-display text-4xl md:text-6xl font-bold text-white mb-6">
            JOSIE'S PORTFOLIO
          </h1>
          <p className="text-xl text-white/80 tracking-wider mb-4">
            Josie Handscomb
          </p>
          <p className="text-base text-white/70 max-w-3xl mx-auto">
            Specializing in ornamental, illustrative, and traditional tattoos with 3 years of experience
          </p>
        </div>
      </section>

      {/* Tab Navigation */}
      <section className="py-8 px-4 border-b border-white/20">
        <div className="max-w-7xl mx-auto flex justify-center gap-8">
          <button
            onClick={() => setActiveTab('tattoos')}
            className={`text-3xl tracking-widest pb-2 transition-colors ${
              activeTab === 'tattoos'
                ? 'text-white border-b-2 border-white'
                : 'text-white/60 hover:text-white/80'
            }`}
          >
            TATTOOS
          </button>
          <button
            onClick={() => setActiveTab('artwork')}
            className={`text-3xl tracking-widest pb-2 transition-colors ${
              activeTab === 'artwork'
                ? 'text-white border-b-2 border-white'
                : 'text-white/60 hover:text-white/80'
            }`}
          >
            ARTWORK
          </button>
        </div>
      </section>

      {/* Tattoos Portfolio */}
      {activeTab === 'tattoos' && (
        <section className="py-12 px-4">
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-white tracking-widest mb-2">
                TATTOO PORTFOLIO
              </h2>
              <p className="text-white/70">
                Completed tattoos showcasing Josie's expertise in ornamental, illustrative, and traditional designs
              </p>
            </div>
            {josieTattoos.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {josieTattoos.map((image) => (
                  <div
                    key={image.id}
                    onClick={() => openLightbox(image)}
                    className="relative w-full pb-[100%] overflow-hidden cursor-pointer group"
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      loading="lazy"
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <div className="text-center">
                        <p className="text-white text-sm tracking-wider">
                          VIEW FULL SIZE
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-white/60 text-lg">
                  Portfolio coming soon...
                </p>
              </div>
            )}
          </div>
        </section>
      )}

      {/* Artwork Portfolio */}
      {activeTab === 'artwork' && (
        <section className="py-12 px-4">
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-white tracking-widest mb-2">
                ARTWORK PORTFOLIO
              </h2>
              <p className="text-white/70">
                Original designs, flash sheets, and custom artwork by Josie
              </p>
            </div>
            {josieArtwork.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {josieArtwork.map((image) => (
                  <div
                    key={image.id}
                    onClick={() => openLightbox(image)}
                    className="relative w-full pb-[100%] overflow-hidden cursor-pointer group"
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      loading="lazy"
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <div className="text-center">
                        <p className="text-white text-sm tracking-wider">
                          VIEW FULL SIZE
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-white/60 text-lg">
                  Artwork coming soon...
                </p>
              </div>
            )}
          </div>
        </section>
      )}

      {/* Lightbox */}
      <Lightbox
        images={activeTab === 'tattoos' ? josieTattoos : josieArtwork}
        selected={selectedImage}
        onSelect={setSelectedImage}
        onClose={closeLightbox}
      />

      {/* CTA Section */}
      <section className="py-20 px-4 border-t border-white/20">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white tracking-widest mb-6">
            READY TO GET INKED?
          </h2>
          <p className="text-white/80 text-lg mb-8">
            Book a consultation with Josie today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="bg-white text-black px-8 py-4 text-sm tracking-widest hover:bg-gray-200 transition-colors"
            >
              CONTACT US
            </button>
            <a
              href="https://www.instagram.com/j.inks.tattoo"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white/10 text-white px-8 py-4 text-sm tracking-widest hover:bg-white/20 transition-colors border border-white/30"
            >
              VIEW INSTAGRAM
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default JosieGallery;
